document.addEventListener('DOMContentLoaded', function () {
  const fomoText = document.querySelector('.fomo-text');

  if (!fomoText) return;

  const slides = Array.from(fomoText.querySelectorAll(':scope > span'));

  if (!slides.length) return;

  let current = 0;
  let sliderInterval = null;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
  }

  function startMobileSlider() {
    if (window.innerWidth > 480) return;

    showSlide(current);

    if (sliderInterval) clearInterval(sliderInterval);

    sliderInterval = setInterval(function () {
      current = (current + 1) % slides.length;
      showSlide(current);
    }, 3000);
  }

  function handleResize() {
    if (window.innerWidth <= 480) {
      startMobileSlider();
    } else {
      if (sliderInterval) {
        clearInterval(sliderInterval);
        sliderInterval = null;
      }

      slides.forEach(slide => {
        slide.classList.remove('active');
      });
    }
  }

  startMobileSlider();

  window.addEventListener('resize', handleResize);
});